/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkItem } from '../models/work-item';

@Injectable({ providedIn: 'root' })
export class WorkItemsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemsV1ControllerGetItemById()` */
  static readonly ItemsV1ControllerGetItemByIdPath = '/v1/items/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV1ControllerGetItemById()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV1ControllerGetItemById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsService.ItemsV1ControllerGetItemByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItem>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV1ControllerGetItemById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV1ControllerGetItemById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkItem> {
    return this.itemsV1ControllerGetItemById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItem>): WorkItem => r.body)
    );
  }

}
